import React from 'react';

const ProgressIndicator = ({ steps, currentStep }) => {
  return (
    <div className="progress-indicator">
      {steps.map((step, index) => (
        <div key={step.id} className="progress-step">
          <div className={`step-circle ${currentStep >= step.id ? 'active' : ''}`}>
            {currentStep >= step.id && <div className="step-dot"></div>}
          </div>
          <span className={`step-label ${currentStep >= step.id ? 'active' : ''}`}>
            {step.label}
          </span>
          {index < steps.length - 1 && <div className="step-connector"></div>}
        </div>
      ))}
    </div>
  );
};

export default ProgressIndicator;
